import { render, staticRenderFns } from "./imgOrVideoShow.vue?vue&type=template&id=3018eab7&"
import script from "./imgOrVideoShow.vue?vue&type=script&lang=ts&"
export * from "./imgOrVideoShow.vue?vue&type=script&lang=ts&"
import style0 from "./imgOrVideoShow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports